import React, { useEffect, useState } from 'react';
import './ClownfishAnimation.css';

const ClownfishAnimation = () => {
  const [scrollDepth, setScrollDepth] = useState(0);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrolled = window.scrollY;
          const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
          const depth = Math.min(scrolled / maxScroll, 1);
          setScrollDepth(depth);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Initial calculation

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  // Only show clownfish between 0-20% of page scroll
  if (scrollDepth > 0.2) {
    return null;
  }

  return (
    <div className="clownfish-animation-container" style={{ 
      opacity: scrollDepth <= 0.2 ? 1 : 0
    }}>
      {/* Four clownfish swimming simultaneously */}
      <div className="animated-clownfish clownfish-1">
        <img src="/clown.gif" alt="" />
      </div>
      <div className="animated-clownfish clownfish-2">
        <img src="/clown.gif" alt="" />
      </div>
      <div className="animated-clownfish clownfish-3">
        <img src="/clown.gif" alt="" />
      </div>
      <div className="animated-clownfish clownfish-4">
        <img src="/clown.gif" alt="" />
      </div>
    </div>
  );
};

export default ClownfishAnimation;